import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { XCloseIcon } from '@flowwai-frontend/design-system/icons'
import { colors } from '@flowwai-frontend/shared/style-guide'

import { ReactBaseModalContainer } from '../ReactBaseModalContainer'
import ErrorBoundaryWrapper from '../ErrorBoundaryWrapper/ErrorBoundaryWrapper'

import * as Styles from './styles'
import './styles.css'

export interface ReactBaseModalContainerV2Props {
   isModalOpen: boolean
   renderUI: () => React.ReactElement
   onClickClose: () => void
   onModalClose?: () => void
   bodyContainerClassName?: string
   containerClassName?: string
   overlayContainerClassName?: string
   shouldShowCloseIcon?: boolean
   closeIconClassName?: string
   shouldReturnFocusAfterClose?: boolean
   shouldCloseOnEsc?: boolean
   shouldCloseOnOverlayClick?: boolean
   errorBoundaryContainerClassName?: string
}

const ReactBaseModalContainerV2 = (
   props: ReactBaseModalContainerV2Props
): React.ReactElement => {
   const {
      isModalOpen,
      containerClassName,
      overlayContainerClassName,
      bodyContainerClassName,
      onClickClose,
      onModalClose,
      shouldShowCloseIcon = true,
      renderUI,
      shouldCloseOnOverlayClick = true,
      shouldCloseOnEsc = true
   } = props

   const renderCloseIcon = () =>
      shouldShowCloseIcon ? (
         <div
            className={cn(
               Styles.iconContainerStyles,
               'modal-v2-close-icon',
               props.closeIconClassName
            )}
            onClick={onClickClose}
         >
            <XCloseIcon width={20} height={20} stroke={colors['gray-700']} />
         </div>
      ) : null

   const renderChildrenWithErrorBoundary = (): React.ReactElement => (
      <ErrorBoundaryWrapper
         falBackErrorViewContainerStyles={cn(
            Styles.errorBoundaryContainerStyles,
            props.errorBoundaryContainerClassName
         )}
         shouldShowActionItem={false}
      >
         {renderUI()}
      </ErrorBoundaryWrapper>
   )

   return (
      <ReactBaseModalContainer
         isOpen={isModalOpen}
         className={cn('modal-v2', containerClassName)}
         overlayClassName={cn('modal-v2-overlay', overlayContainerClassName)}
         hideCloseIcon={true}
         onClickCloseIcon={onClickClose}
         shouldReturnFocusAfterClose={props.shouldReturnFocusAfterClose}
         onModalClose={onModalClose}
         shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
         shouldCloseOnEsc={shouldCloseOnEsc}
      >
         {renderChildrenWithErrorBoundary()}
         {renderCloseIcon()}
      </ReactBaseModalContainer>
   )
}

export default observer(ReactBaseModalContainerV2)
